import React, { useState, useEffect } from 'react';
import { Grid } from 'semantic-ui-react';
import MarketplaceListing from './MarketplaceListing';
import ListingDealExclusionsTable from './ListingDealExclusionsTable';
import { getMarketplaceListingById } from '~/api/marketplace';

interface MarketplaceReviewProps {
    projectId?: string;
    portfolioId?: string;
}

const MarketplaceReview: React.FC<MarketplaceReviewProps> = ({
    projectId,
    portfolioId
}) => {

    const [listing, setListing] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetchListing();
    }, [projectId, portfolioId]);

    const fetchListing = async () => {
        setLoading(true);
        try {
            const data = await getMarketplaceListingById({ projectId, portfolioId });
            if (data.isVisible) {
                setListing(data);
            }
        } catch (err) {
            setError('Failed to load marketplace listing');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="marketplace-review">
            <Grid>
                <Grid.Column mobile={12}>
                    <h2>Conductor Listing</h2>
                    <p>The Conductor team has activated the listing for this deal. What you see below is what investors can see, even before they are invited to bid. This helps us gauge investor interest, and invite the right parties to bid on the opportunity.</p>
                </Grid.Column>

                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <>
                        {error ? (
                            <p>No listing found for this deal.</p>
                        ) : (
                            <>
                                {(listing && listing.isVisible) ? (
                                    <Grid.Column mobile={12} tablet={5} computer={4} largeScreen={4} widescreen={4}>
                                        <MarketplaceListing listing={listing} />
                                    </Grid.Column>
                                ) : (
                                    <>
                                        {projectId
                                            ? window.location.assign(`/project/${projectId}/review`)
                                            : portfolioId
                                                ? window.location.assign(`/portfolio/${portfolioId}/review`)
                                                : null}
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}
            </Grid>

            <ListingDealExclusionsTable projectId={projectId} portfolioId={portfolioId} />
        </div>
    );
};

export default MarketplaceReview;